import * as React from "react";
import {DropdownSelect} from "../";

export class Paginator extends React.Component<
  {
    pages: number[];
    currentPage: number;
    onSelect?: (page: number) => void;
  }
>{
  onSelect(page: number){
    if(this.props.onSelect !== undefined){
      this.props.onSelect(page);
    }
  }

  render(){
    return (
      <div className="newPagination__pages">
        <span className="newPagination__title b-label">Страница:</span>
        {this.props.pages.map((page: number) =>
          page === this.props.currentPage?
            <span className="active" key={page}>{page}</span>
            :
            <a href="javascript:void(0)" key={page} onClick={() => this.onSelect(page)}>{page}</a>
        )}
      </div>
    )
  }
}

export class Limit extends React.Component<
  {
    currentLimit: number;
    onSelect?: (limit: number) => void;
  }
>{
    public select: any;

  onSelect(id: number){
    if(this.props.onSelect !== undefined){
      this.props.onSelect(id);
    }
  }

  render(){
    return (
      <div className="newPagination__perpage">
        <label className="newPagination__title">
          Показывать:
        </label>
        <div className="newPagination__perpage__select">
          <DropdownSelect
              title={this.props.currentLimit > 999 ? 'Все результаты' : this.props.currentLimit.toString()}
              onChange={this.onSelect.bind(this)}
          >
            <DropdownSelect.Item id={10}>10</DropdownSelect.Item>
            <DropdownSelect.Item id={20}>20</DropdownSelect.Item>
            <DropdownSelect.Item id={50}>50</DropdownSelect.Item>
            <DropdownSelect.Item id={1000}>Все результаты</DropdownSelect.Item>
          </DropdownSelect>
        </div>
      </div>
    );
  }
}
